import axios from 'axios';

const extractJSON = response => response.data;

export default ({
  market, language, refreshToken,
}) => axios({
  // eslint-disable-next-line no-underscore-dangle
  url: `${window._env_.PUBLIC_URL || '/'}${market}/${language}/refreshToken/?refreshToken=${refreshToken}`,
  method: 'get',
  headers: {
    version: '1.18.0',
  },
}).then(extractJSON)
  .catch(e => ({ error: e }));
